export const CAN_USE_DOM: boolean = typeof window !== "undefined"
  && typeof window.document !== "undefined"
  && typeof window.document.createElement !== "undefined";

export const IS_APPLE: boolean = CAN_USE_DOM && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
